var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.63,
    height: 49.642,
    viewBox: "0 0 43.63 49.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300,60h8.726v2.909H300Zm0,0",
    transform: "translate(-270.913 -54.183)",
    fill: "#f90000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120,60h2.909v2.909H120Zm0,0",
    transform: "translate(-108.365 -54.183)",
    fill: "#f90000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60,60h2.909v2.909H60Zm0,0",
    transform: "translate(-54.183 -54.183)",
    fill: "#f90000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300,180h8.726v2.909H300Zm0,0",
    transform: "translate(-270.913 -162.548)",
    fill: "#f90000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120,180h2.909v2.909H120Zm0,0",
    transform: "translate(-108.365 -162.548)",
    fill: "#f90000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60,180h2.909v2.909H60Zm0,0",
    transform: "translate(-54.183 -162.548)",
    fill: "#f90000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270,422h5.817v2.909H270Zm0,0",
    transform: "translate(-243.822 -381.085)",
    fill: "#f90000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.635,35.1h7.272a4.368,4.368,0,0,0,4.363-4.363V26.178H43.63V0H0V26.178H20.361v4.557a1.456,1.456,0,0,1-1.454,1.454H11.635a5.817,5.817,0,1,0,0,11.635h8.872a7.284,7.284,0,0,0,7.126,5.817h8.726a7.272,7.272,0,0,0,0-14.543H27.632a7.284,7.284,0,0,0-7.126,5.817H11.635a2.909,2.909,0,0,1,0-5.817ZM2.909,2.909H40.722v8.726H2.909Zm0,11.635H40.722v8.726H2.909ZM27.632,38.007h8.726a4.363,4.363,0,0,1,0,8.726H27.632a4.363,4.363,0,1,1,0-8.726Zm0,0",
    fill: "#f90000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.316148bf6fb880b1fd95468d582701b7.svg";
export { ForwardRef as ReactComponent };